"use strict";
const options = {
    collectionsLoadMore: '.collections-load-more',
    blsLinkFilter: '.bls__link-filter',
    openFilter: '.filter-title .open-children-toggle',
    rangeSlider: '.price-range .range-slider',
    rangeSliderMin: '.range-slider-min',
    rangeSliderMax: '.range-slider-max',
    gridMode: '.grid-mode-show-type-products .grid-mode',
    viewMode: '.view-mode',
    sidebarClose: '.sidebar-close',
    collectionSidebar: '#CollectionSidebar',
    collectionFiltersForm: '#CollectionFiltersForm',
    btnFilter: '.collection-filter .btn-filter',
    section: '.section-collection-product',
    toolbarSorter: '.toolbar-sorter .select-selected',
    facetFiltersSort: '.facet-filters__sort li',
    overlay: '.bls__overlay',
    filterSortMb: '.toolbar-sorter-mb .facet-filters__label',
    dataSortMb: '.toolbar-sorter-mb__option',
    closeSortMb: '.close-select'
};

var BlsEventCollectionShopify = (function() {
    return {
        init: function() {
            this.setupEventListeners();
            this.eventLoadMore();
            this.ionRangeSlider();
            this.actionDesc();
        },

        actionDesc: function(){
            const viewMore = document.querySelector('[data-view-more]');
            if (viewMore) {
                viewMore.addEventListener('click', function(e) {
                    const target = e.currentTarget;
                    if (target.closest('.heading-description').classList.contains('show-full-desc')) {
                        target.closest('.heading-description').classList.remove('show-full-desc');
                        target.textContent = target.dataset.readMore
                    } else {
                        target.closest('.heading-description').classList.add('show-full-desc');
                        target.textContent = target.dataset.readLess
                    }
                });
            }
        },

        setupEventListeners: function() {
            document.querySelectorAll(options.btnFilter).forEach(btn => {
                btn.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    if (document.querySelector(options.collectionSidebar).classList.contains('bls__opend-popup')) {
                        target.classList.remove('actived')
                        document.querySelector(options.collectionSidebar).classList.remove('bls__opend-popup');
                        document.querySelector(options.overlay).classList.add('d-none-overlay');
                        document.documentElement.classList.remove('hside_opened');
                        if (target.closest('.collection-filter').classList.contains('dropdonw_sidebar')) {
                            if (window.innerWidth >= 1024) {
                                slideAnime({
                                    target: target.closest('#productgridcontainer').querySelector('#CollectionSidebar'),
                                    animeType: 'slideToggle'
                                });
                            }
                        }
                        target.classList.remove('actived')
                    } else {
                        target.classList.add('actived')
                        document.querySelector(options.collectionSidebar).classList.add('bls__opend-popup');
                        if (!target.closest('.collection-filter').classList.contains('dropdonw_sidebar')) {
                            document.querySelector(options.overlay).classList.remove('d-none-overlay');
                            document.documentElement.classList.add('hside_opened');
                        } else {
                            if (window.innerWidth < 1024) {
                                document.querySelector(options.overlay).classList.remove('d-none-overlay');
                                document.documentElement.classList.add('hside_opened');
                            } else {
                                slideAnime({
                                    target: target.closest('#productgridcontainer').querySelector('#CollectionSidebar'),
                                    animeType: 'slideToggle'
                                });
                            }
                        }
                    }
                }, false);
            });

            document.querySelectorAll(options.openFilter).forEach(btn => {
                btn.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    slideAnime({
                        target: target.closest('.filter-item').querySelector('.filter-content'),
                        animeType: 'slideToggle'
                    });
                    if (target.classList.contains('active')) {
                        target.classList.remove('active');
                    } else {
                        target.classList.add('active')
                    }
                }, false);
            });

            document.querySelectorAll(options.sidebarClose).forEach(btn => {
                btn.addEventListener("click", event => {
                    event.preventDefault();
                    document.querySelector(options.collectionSidebar).classList.remove('bls__opend-popup');
                    if (document.querySelector(options.btnFilter)) {
                        document.querySelector(options.btnFilter).classList.remove('actived');
                    }
                    document.querySelector(options.overlay).classList.add('d-none-overlay');
                    document.documentElement.classList.remove('hside_opened');
                }, false);
            });

            document.querySelectorAll(options.viewMode).forEach(view => {
                view.addEventListener("click", event => {
                    event.preventDefault();
                  
                    const target = event.currentTarget;
                    const view_mode = target.getAttribute('data-view');
                    if (target.classList.contains('actived')) return;
                    var queryString = window.location.search;
                    queryString = this.removeParam('view', queryString);
                    if (view_mode == 'list') {
                        var searchParams = queryString.replace('?', '')+'&view=list';
                    } else {
                        var searchParams = queryString.replace('?', '')+'&view=grid';
                    }
                    const url = this.renderUrl(searchParams);
                    this.renderSectionFilter(url, searchParams);
                }, false);
            });

            document.querySelectorAll(options.gridMode).forEach(btn => {
                btn.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    const view_mode = target.getAttribute('data-grid-mode');
                    if (target.classList.contains('actived')) return;
                    if (view_mode == 1) return;
                    for (var item of document.querySelectorAll(options.gridMode)) {
                        item.classList.remove('actived');
                    }
                    const container_switch = document.querySelector('.container-products-switch');
                    target.classList.add('actived');
                    const data_view_mode = container_switch.getAttribute('data-view-mode');
                    container_switch.classList.remove('grid-columns-'+data_view_mode);
                    container_switch.setAttribute('data-view-mode',view_mode);
                    container_switch.classList.add('grid-columns-'+view_mode);
                }, false);
            });

            document.querySelectorAll(options.blsLinkFilter).forEach(btn => {
                btn.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    if (target.querySelector('.bls_tooltip')) {
                        target.querySelector('.bls_tooltip').classList.toggle('current-filter');
                    } else {
                        target.closest('li').classList.toggle('current-filter');
                    }
                    const url = target.getAttribute('href');
                    this.renderSectionFilter(url);
                }, false);
            });

            document.body.addEventListener('click', (evt) => {
                const target = evt.target;
                const btn_dropdonw_sidebar = document.querySelector('.collection-filter.dropdonw_sidebar .btn-filter'); 
                if (!target.closest('.select-custom') && target != document.querySelector('.toolbar-sorter .select-custom')) {
                    if (document.querySelector('.toolbar-sorter .select-custom')) {
                        document.querySelector('.toolbar-sorter .select-custom').classList.remove('actived');
                    }
                }
                if (!target.closest('#CollectionSidebar') && target != document.querySelector('#CollectionSidebar') && btn_dropdonw_sidebar && target != btn_dropdonw_sidebar) {
                    if (window.innerWidth >= 1024) {
                        btn_dropdonw_sidebar.classList.remove('actived')
                        document.querySelector(options.collectionSidebar).classList.remove('bls__opend-popup');
                        document.querySelector(options.overlay).classList.add('d-none-overlay');
                        document.documentElement.classList.remove('hside_opened');
                        slideAnime({
                            target: btn_dropdonw_sidebar.closest('#productgridcontainer').querySelector('#CollectionSidebar'),
                            animeType: 'slideUp'
                        });
                    }
                }
            });

            document.querySelectorAll(options.toolbarSorter).forEach(filterSort => {
                filterSort.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    if (target.closest('.select-custom').classList.contains('actived')) {
                        target.closest('.select-custom').classList.remove('actived');
                    } else {
                        target.closest('.select-custom').classList.add('actived');
                    }
                }, false);
            });
            
            if (document.querySelector(options.filterSortMb)) {
                document.querySelector(options.filterSortMb).addEventListener('click' , event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    if (target.closest('.toolbar-sorter-mb').classList.contains('open-selected')) {
                        target.closest('.toolbar-sorter-mb').classList.remove('open-selected')
                    } else {
                        target.closest('.toolbar-sorter-mb').classList.add('open-selected')
                    }
                }, false);
            }
            
            if (document.querySelector(options.closeSortMb)) {
                document.querySelector(options.closeSortMb).addEventListener('click', event => {
                    event.preventDefault();
                    document.querySelector('.toolbar-sorter-mb').classList.remove('open-selected')
                })
            }

            document.querySelectorAll(options.facetFiltersSort).forEach(filterSort => {
                filterSort.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    const value = target.getAttribute('value');
                    var queryString = window.location.search;
                    queryString = this.removeParam('sort_by', queryString);
                    var searchParams = queryString.replace('?', '')+'&sort_by='+value;
                    const url = this.renderUrl(searchParams);
                    this.renderSectionFilter(url, searchParams);


                }, false);
            });
        },

        ionRangeSlider: function() {
            const price_range = document.querySelector('.price-range');
            const maxRange = document.querySelector(options.rangeSliderMax);
            const minRange = document.querySelector(options.rangeSliderMin);
            const minPrice = document.querySelector('.min-price-range');
            const maxPrice = document.querySelector('.max-price-range');
            var minPriceRange = 0;
            var maxPriceRange = 0;
            if (!price_range) return;
            document.querySelector(options.rangeSliderMin).addEventListener("input", event => {
                event.preventDefault();
                const target = event.currentTarget;
                if (Number(maxRange.value) - Number(target.value) >= 1) {
                    minPrice.value = Number(target.value);
                    minPriceRange = Number(target.value) * 100;
                } else {
                    target.value = Number(maxRange.value) - 1;
                    minPriceRange = (Number(maxRange.value) - 1)*100;
                }
                const price_format = Shopify.formatMoney(minPriceRange, cartStrings.money_format);
                document.querySelector('.price-lable .min').innerHTML = price_format;
                target.closest(".price-range").style.setProperty('--range-from', minRange.value / Number(target.getAttribute('max')) * 100 + '%');
            }, false);
            document.querySelector(options.rangeSliderMax).addEventListener("input", event => {
                event.preventDefault();
                const target = event.currentTarget;
                if (target.value - minRange.value >= 1) {
                    maxPrice.value = target.value;
                    maxPriceRange = Number(target.value) * 100;
                } else {
                    target.value = Number(minRange.value) + Number(1);
                    maxPriceRange = (Number(minRange.value) + Number(1)) * 100;
                }
                const price_format = Shopify.formatMoney(maxPriceRange, cartStrings.money_format);
                document.querySelector('.price-lable .max').innerHTML = price_format;
                target.closest(".price-range").style.setProperty('--range-to', maxRange.value / Number(target.getAttribute('max')) * 100 + '%');
            }, false);
            document.querySelectorAll(options.rangeSlider).forEach(sliderRange => {
                sliderRange.addEventListener("change", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    const formData = new FormData(document.querySelector(options.collectionFiltersForm));
                    const params = new URLSearchParams(formData).toString();
                    const nameMin = minPrice.getAttribute('name');
                    const nameMax = maxPrice.getAttribute('name');
                    var queryString = window.location.search;
                    queryString = this.removeParam(nameMin, queryString);
                    queryString = this.removeParam(nameMax, queryString);
                    var searchParams = queryString.replace('?', '')+'&'+params;
                    const url = this.renderUrl(searchParams);
                    this.renderSectionFilter(url, searchParams);
                }, false);
            });
        },

        removeParam: function(key, sourceURL) {
            var rtn = sourceURL.split("?")[0],
                param,
                params_arr = [],
                queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
            if (queryString !== "") {
                params_arr = queryString.split("&");
                for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                    param = params_arr[i].split("=")[0];
                    if (param === key) {
                        params_arr.splice(i, 1);
                    }
                }
                if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
            }
            return rtn;
        },

        renderUrl: function(searchParams) {
            const sectionId = document.querySelector(options.section).dataset.sectionId;
            const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
            return url;
        },

        renderSectionFilter: function(url, searchParams) {
            if (this._prefetchController) {
                this._prefetchController.abort();
                this._prefetchController = null;
            }
            this._prefetchData = null;
            this._prefetchPromise = null;
            this._prefetchUrl = null;
            if (this._observer) {
                this._observer.disconnect();
                this._observer = null;
            }

            this.toggleLoading(document.body, true);
            fetch(`${url}`)
                .then((response) => {
                    if (!response.ok) {
                    var error = new Error(response.status);
                    throw error;
                    }
                    return response.text();
                })
                .then(responseText => {
                    const newSection = new DOMParser().parseFromString(responseText, 'text/html').querySelector(options.section);
                    document.querySelector(options.section).replaceWith(newSection);
                    document.querySelector(options.overlay).classList.add('d-none-overlay');
                    document.documentElement.classList.remove('hside_opened');
                    this.toggleLoading(document.body, false);
                })
                .catch((error) => {
                    throw error;
                })
                .finally(() => {
                    BlsReloadSpr.init();
                    BlsEventCollectionShopify.init();
                    BlsColorSwatchesShopify.init();
                    BlsSubActionProduct.init();
                    setTimeout(function() {
                        BlsLazyloadImg.init();
                    }, 200);
                });
            this.updateUrl(url, searchParams);
        },

        schedulePrefetch: function(url) {
            if (!url) return;
            const normalizeUrl = (u) => u ? u.split('#')[0].replace(/\/$/, '') : '';
            if (this._prefetchData && normalizeUrl(this._prefetchData.url) === normalizeUrl(url)) return;
            if (this._prefetchUrl && normalizeUrl(this._prefetchUrl) === normalizeUrl(url)) return;

            if (this._prefetchTimeout) {
                clearTimeout(this._prefetchTimeout);
            }

            const _this = this;
            const runPrefetch = () => {
                if (_this._prefetchController) {
                    _this._prefetchController.abort();
                }
                _this._prefetchController = new AbortController();
                _this._prefetchUrl = url;

                _this._prefetchPromise = (async () => {
                    try {
                        const res = await fetch(url, { signal: _this._prefetchController.signal });
                        if (!res.ok) return null;
                        const responseText = await res.text();
                        const domParser = typeof parser !== 'undefined' ? parser : new DOMParser();
                        const dom = domParser.parseFromString(responseText, 'text/html');
                        const productNodesHtml = dom.querySelectorAll('#bls__product-grid .bls__grid__item');
                        const load_more = dom.querySelector('.collections-load-more');
                        const amountNode = dom.querySelector('.load-more-amount');
                        const percentNode = dom.querySelector('.load-more-percent');

                        _this._prefetchData = {
                            url: url,
                            productNodesHtml: productNodesHtml,
                            nextHref: load_more ? load_more.getAttribute('href') : null,
                            nextDataUrl: load_more ? (load_more.getAttribute('data-url') || load_more.getAttribute('href')) : null,
                            amountText: amountNode ? amountNode.textContent : null,
                            percentWidth: percentNode ? percentNode.style.width : null,
                            hasMore: !!load_more
                        };
                        return _this._prefetchData;
                    } catch (err) {
                        return null;
                    } finally {
                        _this._prefetchPromise = null;
                        _this._prefetchUrl = null;
                    }
                })();
            };

            if ('requestIdleCallback' in window) {
                window.requestIdleCallback(runPrefetch, { timeout: 1200 });
            } else {
                this._prefetchTimeout = setTimeout(runPrefetch, 150);
            }
        },

        eventLoadMore: function() {
            var _this = this;
            document.querySelectorAll(options.collectionsLoadMore).forEach(loadMore => {
                if (loadMore.dataset.boundLoadMore) return;
                loadMore.dataset.boundLoadMore = "true";

                // Always prevent default link click navigation to prevent opening raw section URLs
                loadMore.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    if (!target.classList.contains('loading')) {
                        _this.loadMoreProducts(target);
                    }
                }, false);

                if (loadMore.classList.contains('infinit-scrolling')) {
                    if (_this._observer) {
                        _this._observer.disconnect();
                    }
                    _this._observer = new IntersectionObserver(function (entries) {
                        entries.forEach(entry => {
                            if (entry.isIntersecting && !loadMore.classList.contains('loading')) {
                                _this.loadMoreProducts(loadMore);
                            }
                        });
                    }, { rootMargin: '1200px 0px 1200px 0px', threshold: 0 });
                    _this._observer.observe(loadMore);

                    const initialUrl = loadMore.getAttribute('data-url') || loadMore.getAttribute('href');
                    if (initialUrl) {
                        _this.schedulePrefetch(initialUrl);
                    }

                    if (!_this._scrollBound) {
                        _this._scrollBound = true;
                        let ticking = false;
                        window.addEventListener('scroll', () => {
                            if (ticking) return;
                            ticking = true;
                            requestAnimationFrame(() => {
                                ticking = false;
                                const currentBtn = document.querySelector('.collections-load-more.infinit-scrolling');
                                if (!currentBtn || currentBtn.classList.contains('loading')) return;
                                const rect = currentBtn.getBoundingClientRect();
                                if (rect.top <= window.innerHeight + 1000) {
                                    _this.loadMoreProducts(currentBtn);
                                }
                            });
                        }, { passive: true });
                    }
                }
            });
        },

        loadMoreProducts: function(target) {
            const loadMore_url = target.getAttribute('data-url') || target.getAttribute('href');
            if (!loadMore_url) return;
            if (target.classList.contains('loading')) return;

            this.toggleLoading(target, true);
            const _this = this;
            const normalizeUrl = (u) => u ? u.split('#')[0].replace(/\/$/, '') : '';

            const applyBatch = (data) => {
                const grid = document.getElementById("bls__product-grid");
                if (grid && data.productNodesHtml && data.productNodesHtml.length > 0) {
                    const fragment = document.createDocumentFragment();
                    data.productNodesHtml.forEach(prodNode => {
                        fragment.appendChild(prodNode);
                    });
                    grid.appendChild(fragment);
                }

                if (data.amountText && document.querySelector(".load-more-amount")) {
                    document.querySelector(".load-more-amount").innerHTML = data.amountText;
                }
                if (data.percentWidth && document.querySelector(".load-more-percent")) {
                    document.querySelector(".load-more-percent").style.width = data.percentWidth;
                }

                if (data.hasMore && (data.nextDataUrl || data.nextHref)) {
                    if (data.nextHref) target.setAttribute("href", data.nextHref);
                    if (data.nextDataUrl) target.setAttribute("data-url", data.nextDataUrl);
                    
                    if (target.classList.contains('infinit-scrolling')) {
                        if (_this._observer) {
                            _this._observer.disconnect();
                            _this._observer.observe(target);
                        }
                        _this.schedulePrefetch(data.nextDataUrl || data.nextHref);
                    }
                } else {
                    if (_this._observer) _this._observer.disconnect();
                    target.remove();
                }
                _this.toggleLoading(target, false);
            };

            const cleanupAndInit = () => {
                if (window.BlsColorSwatchesShopify) BlsColorSwatchesShopify.init();
                if (window.BlsSubActionProduct) BlsSubActionProduct.init();
                if (window.BlsReloadSpr) BlsReloadSpr.init();
                if (window.BlsLazyloadImg) {
                    BlsLazyloadImg.init();
                }
            };

            // 1. Check if cached
            if (this._prefetchData && normalizeUrl(this._prefetchData.url) === normalizeUrl(loadMore_url)) {
                const cached = this._prefetchData;
                this._prefetchData = null;
                applyBatch(cached);
                cleanupAndInit();
                return;
            }

            // 2. Check if in flight
            if (this._prefetchPromise && this._prefetchUrl && normalizeUrl(this._prefetchUrl) === normalizeUrl(loadMore_url)) {
                this._prefetchPromise.then(prefetchResult => {
                    if (prefetchResult && normalizeUrl(prefetchResult.url) === normalizeUrl(loadMore_url)) {
                        _this._prefetchData = null;
                        applyBatch(prefetchResult);
                        cleanupAndInit();
                    } else {
                        _this.fetchAndApply(loadMore_url, target);
                    }
                }).catch(() => {
                    _this.fetchAndApply(loadMore_url, target);
                });
                return;
            }

            // 3. Direct fetch fallback
            this.fetchAndApply(loadMore_url, target);
        },

        fetchAndApply: function(loadMore_url, target) {
            const _this = this;
            fetch(`${loadMore_url}`)
                .then((response) => {
                    if (!response.ok) {
                        var error = new Error(response.status);
                        throw error;
                    }
                    return response.text();
                })
                .then(responseText => {
                    const domParser = typeof parser !== 'undefined' ? parser : new DOMParser();
                    const productNodes = domParser.parseFromString(responseText, 'text/html');
                    const productNodesHtml = productNodes.querySelectorAll('#bls__product-grid .bls__grid__item');
                    const grid = document.getElementById("bls__product-grid");
                    if (grid && productNodesHtml.length > 0) {
                        const fragment = document.createDocumentFragment();
                        productNodesHtml.forEach(prodNode => fragment.appendChild(prodNode));
                        grid.appendChild(fragment);
                    }
                    const load_more = productNodes.querySelector('.collections-load-more');
                    const amountNode = productNodes.querySelector('.load-more-amount');
                    const percentNode = productNodes.querySelector('.load-more-percent');
                    if (amountNode && document.querySelector(".load-more-amount")) {
                        document.querySelector(".load-more-amount").innerHTML = amountNode.textContent;
                    }
                    if (percentNode && document.querySelector(".load-more-percent")) {
                        document.querySelector(".load-more-percent").style.width = percentNode.style.width;
                    }
                    if (load_more) {
                        target.setAttribute("href", load_more.getAttribute('href'));
                        const nextDataUrl = load_more.getAttribute('data-url') || load_more.getAttribute('href');
                        target.setAttribute("data-url", nextDataUrl);
                        if (target.classList.contains('infinit-scrolling')) {
                            if (_this._observer) {
                                _this._observer.disconnect();
                                _this._observer.observe(target);
                            }
                            _this.schedulePrefetch(nextDataUrl);
                        }
                    } else {
                        if (_this._observer) _this._observer.disconnect();
                        target.remove();
                    }
                    _this.toggleLoading(target, false);
                })
                .catch((error) => {
                    _this.toggleLoading(target, false);
                    console.error('Collection load more error:', error);
                })
                .finally(() => {
                    if (window.BlsColorSwatchesShopify) BlsColorSwatchesShopify.init();
                    if (window.BlsSubActionProduct) BlsSubActionProduct.init();
                    if (window.BlsReloadSpr) BlsReloadSpr.init();
                    if (window.BlsLazyloadImg) {
                        BlsLazyloadImg.init();
                    }
                });
        },

        toggleLoading: function(event, loading) {
            if (event) {
                if (loading) {
                  event.classList.add('start', 'loading');
                } else {
                  event.classList.remove('loading', 'start');
                  event.classList.add('finish');
                  setTimeout(function() {
                    event.classList.remove('finish');
                  }, 250);
                }
            }
        },

        updateUrl: function(url, searchParams = false) {
            if (searchParams) {
                const urlUpdate = `${window.location.pathname}?${searchParams}`;
                window.history.pushState({url: urlUpdate}, '', urlUpdate);
            } else {
                window.history.pushState({url: url}, '', url);
            }
        }
    }
})();
BlsEventCollectionShopify.init();